import React, { createContext, useContext, useState, useCallback } from "react";

const DrawerCtx = createContext({
  open: false,
  product: null,
  openDrawer: () => {},
  closeDrawer: () => {},
});

export const DrawerProvider = ({ children }) => {
  const [open, setOpen]       = useState(false);
  const [product, setProduct] = useState(null);

  const openDrawer = useCallback((p) => {
    setProduct(p);
    setOpen(true);
  }, []);

  const closeDrawer = useCallback(() => {
    setOpen(false);
    // Clear product after close animation (300ms)
    setTimeout(() => setProduct(null), 350);
  }, []);

  return (
    <DrawerCtx.Provider value={{ open, product, openDrawer, closeDrawer }}>
      {children}
    </DrawerCtx.Provider>
  );
};

export const useDrawer = () => useContext(DrawerCtx);
